import { render, staticRenderFns } from "./SlidingBayBrokenTiles.vue?vue&type=template&id=9b45bda8&scoped=true"
import script from "./SlidingBayBrokenTiles.vue?vue&type=script&lang=ts"
export * from "./SlidingBayBrokenTiles.vue?vue&type=script&lang=ts"
import style0 from "./SlidingBayBrokenTiles.vue?vue&type=style&index=0&id=9b45bda8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b45bda8",
  null
  
)

export default component.exports